module.exports = __webpack_public_path__ + "img/267.refrigerators_show.0675e436.svg";